"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlusIcon64Regular = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.PlusIcon64Regular = forwardRef_1.forwardRef('PlusIcon64Regular', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 64 }, props),
        react_1.default.createElement("path", { d: "M32 9.5a1.5 1.5 0 0 1 1.5 1.5v19.5H53a1.5 1.5 0 0 1 0 3H33.5V53a1.5 1.5 0 0 1-3 0V33.5H11a1.5 1.5 0 0 1 0-3h19.5V11A1.5 1.5 0 0 1 32 9.5Z" })));
});
